import { Button, Table, Input, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ProductModal from "./components/ProductModal";
import NewProductModal from "./components/NewProductForm";
import { fetchProducts } from "../../utilities/redux/slices/productsSlice";
import axiosInstance from "utilities/axios";

const Products = () => {
	const dispatch = useDispatch();

	const [products, setProducts] = useState([]);
	const [search, setSearch] = useState("");

	const [selectedProduct, setSelectedProduct] = useState(null);
	const [openModal, setOpenModal] = useState(false);

	const [openNewProductModal, setOpenNewProductModal] = useState(false);

	useEffect(() => {
    axiosInstance
      .get('/products/product-lines', { params: { search } })
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        notification.error({
          message: "Error fetching products",
          description: error.message,
        });
      });
	}, [search]);

	const columns = [
		{
			title: "Brand",
			dataIndex: "brand",
			key: "brand",
			sorter: (a, b) => a.brand.localeCompare(b.brand),
		},
		{
			title: "Product Family",
			dataIndex: "family",
			key: "family",
			sorter: (a, b) => a.family.localeCompare(b.family),
		},
		{
			title: "Product Line",
			dataIndex: "name",
			key: "name",
			sorter: (a, b) => a.name.localeCompare(b.name),
		},
		{
			title: "Tech Level",
			dataIndex: "techLevel",
			key: "techLevel",
			sorter: (a, b) => a.techLevel.localeCompare(b.techLevel),
		},
		{
			title: "Details",
			dataIndex: "",
			key: "x",
			width: 100,
			render: (text, record) => (
				<Button
					onClick={() => {
						setSelectedProduct(record);
						setOpenModal(true);
					}}
				>
					Details
				</Button>
			)
		}
	];

  return (
		<>
			<div style={{ padding: "32px" }}>
				<div style={{ display: "flex" }}>
					<Input.Search
						placeholder="Search Product"
						allowClear
						size="large"
						value={search}
						onChange={(event) => {
							setSearch(event.target.value);
						}}
					/>
					<Button
						type="primary"
						style={{ marginLeft: "8px" }}
						onClick={() => {
						setOpenNewProductModal(true);
						}}
						icon={<PlusOutlined />}
						size="large"
					>
						New Product
					</Button>
				</div>
				<div style={{ marginTop: "16px" }}>
					<Table
						bordered
						dataSource={products}
						columns={columns}
						rowKey="id"
					/>
				</div>
			</div>
			<ProductModal
				product={selectedProduct}
				visible={openModal}
				onClose={() => {
					setOpenModal(false);
					setSelectedProduct(null);
				}}
				onChange={() => {
					axiosInstance
            .get('/products/product-lines', { params: { search } })
            .then((response) => {
              setProducts(response.data);
            })
            .catch((error) => {
              notification.error({
                message: "Error fetching products",
                description: error.message,
              });
            }); 

					if (selectedProduct) {
						setSelectedProduct(products.find((product) => product.id === selectedProduct.id));
					}
				}}
			/>
			<NewProductModal
				visible={openNewProductModal}
				onClose={() => {
					setOpenNewProductModal(false);
				}}
				onChange={() => {
          axiosInstance
            .get('/products/product-lines', { params: { search } })
            .then((response) => {
              setProducts(response.data);
            })
            .catch((error) => {
              notification.error({
                message: "Error fetching products",
                description: error.message,
              });
            });
        }}
			/>
		</>
	);
};

export default Products;